import { useState, useEffect } from 'react';

// Modo oscuro del panel admin (fase 1: lienzo oscuro + dashboard).
// Estado desacoplado via localStorage + eventos, para que el toggle (en el
// drawer) y cualquier vista (p.ej. Dashboard) se mantengan sincronizados sin
// prop-drilling ni context global.
const KEY = 'movex_panel_dark';
const EVT = 'movex-panel-theme';

export const getPanelDark = () => {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch (e) {
    return false;
  }
};

export const setPanelDark = (value) => {
  try {
    localStorage.setItem(KEY, value ? '1' : '0');
  } catch (e) { /* noop */ }
  try {
    window.dispatchEvent(new Event(EVT));
  } catch (e) { /* noop */ }
};

export const usePanelDark = () => {
  const [dark, setDark] = useState(getPanelDark());
  useEffect(() => {
    const sync = () => setDark(getPanelDark());
    window.addEventListener(EVT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(EVT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);
  return dark;
};

export const PANEL_DARK_BG = '#0f1115';
export const PANEL_DARK_TEXT = '#e8eaed';
